module.exports = __webpack_public_path__ + "static/media/safety-hydraulics-2.e44396f1.png";